import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { eventImage } from '../../core/helpers';
import { EventService } from '../../core/services/event.service';
import { ToastService } from '../../core/services/toast.service';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'gs-my-event-list',
    templateUrl: './my-event-list.component.html',
    standalone: false
})
export class MyEventListComponent implements OnInit, OnDestroy {
  tabs = {
    EVENTS: 0,
    INVITATIONS: 1
  };

  selectedTab: number = this.tabs.EVENTS;

  events: any[];
  filteredEvents: any[] = [];
  searchEvents: string = '';

  invitations: any[];
  filteredInvitations: any[] = [];
  searchInvitations: string = '';

  private subscriptions: Subscription[] = [];

  constructor(
    private eventService: EventService,
    private toastService: ToastService,
private viewportScroller: ViewportScroller
  ) { }

  ngOnInit() {
    this.getEvents();
    this.getInvitations();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getEvents() {
    this.subscriptions.push(
      this.eventService.getEvents()
        .pipe(
          catchError(e => {
            this.toastService.checkErrorForStatus(e);
            return throwError(e);
          }),
          finalize(() => { })
        )
        .subscribe((response: any) => {

          response.items.forEach((x) => {
            x.image = eventImage(x);
          });

          this.events = response.items;
          this.filterEvents();
        })
    );
  }

  /**
   * Events list that is Invited to user.
   */
  getInvitations() {
    this.subscriptions.push(
      this.eventService.getEventInvitations()
        .pipe(
          catchError(e => {
            this.toastService.checkErrorForStatus(e);
            return throwError(e);
          }),
          finalize(() => { })
        )
        .subscribe((response: any) => {
          response.items.forEach((x) => {
            x.image = eventImage(x);
          });

          this.invitations = response.items;
          this.filterInvitations();
        })
    );
  }

  onTabSelected(id: number) {
    this.selectedTab = id;
    this.scroll();
  }

  onFilterEventsChange() {
    this.filterEvents();
    this.scroll();
  }

  onFilterInvitationsChange() {
    this.filterInvitations();
    this.scroll();
  }

  private filterEvents() {
    if (!this.events) {
      return;
    }

    this.filteredEvents = this.events.filter(x => x.name.toLowerCase().indexOf(this.searchEvents.toLowerCase()) > -1)
  }

  private filterInvitations() {
    if (!this.invitations) {
      return;
    }

    this.filteredInvitations = this.invitations.filter(x => x.name.toLowerCase().indexOf(this.searchInvitations.toLowerCase()) > -1);
  }

  private scroll() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
